<p-breadcrumb [home]="home" [model]="breadcrumb" styleClass="p-mb-3">
</p-breadcrumb>
<div class="card">
  <div class="header-with-button">
    <div class="p-d-flex p-ai-center">
      <h3>{{ existingReport ? existingReport.name : 'New Report' }}</h3>
      <p-message
        severity="warn"
        text="This report has unsaved changes"
        styleClass="p-ml-2"
        *ngIf="hasChanges"
      >
      </p-message>
    </div>
    <p-button
      *ngIf="!existingReport"
      label="Save"
      tooltipPosition="left"
      class="p-mr-2"
      icon="pi pi-save"
      (onClick)="openCreateDynamicReportDialog()"
      [disabled]="saving"
      [outlined]="true"
    ></p-button>
    <p-splitButton
      *ngIf="existingReport"
      label="Save"
      [pTooltip]="hasChanges ? '' : 'No changes to save'"
      tooltipPosition="left"
      class="p-mr-2"
      icon="pi pi-save"
      (onClick)="updateReport()"
      [disabled]="saving"
      [buttonDisabled]="existingReport && !hasChanges"
      [outlined]="true"
      [model]="existingReportActions"
      appendTo="body"
    ></p-splitButton>
  </div>
  <p *ngIf="existingReport">{{ existingReport.description }}</p>
  <p-messages
    *ngIf="freyaHelper.inRootOrCorporateZone"
    severity="warn"
    styleClass="p-mb-2"
  >
    <ng-template pTemplate>
      <div>
        <b>You are running this report in a corporate zone.</b>
        <br />
        <span
          >This may impact performance application-wide. Please be mindful not
          to run this during operation hours, and to select a reasonable
          reporting period.</span
        >
      </div>
    </ng-template>
  </p-messages>

  <div class="p-col" [formGroup]="reportParamsForm" *ngIf="reportParamsForm">
    <div class="p-grid">
      <div class="p-col-12 p-md-4">
        <label
          >Filter By
          <app-info-circle
            class="info-circle"
            pTooltip="May affect totals, e.g., a job may have been created this month, while the event was scheduled for next month (or not scheduled yet)."
          ></app-info-circle>
        </label>
        <br />
        <p-dropdown
          [options]="periodTypeOptions"
          formControlName="periodType"
          optionValue="option"
          styleClass="full-width"
          appendTo="body"
        >
          <ng-template pTemplate="item" let-periodType>
            {{ periodType.label }}
            <ng-container *ngIf="periodTypeDescriptions[periodType.option]">
              <br />
              <small>{{ periodTypeDescriptions[periodType.option] }}</small>
            </ng-container>
          </ng-template>
        </p-dropdown>
      </div>
      <div class="p-col-12 p-md-4">
        <label>Period</label>
        <br />
        <p-dropdown
          [options]="periods"
          formControlName="period"
          optionLabel="name"
          optionValue="value"
          filter="true"
          styleClass="full-width"
          appendTo="body"
        ></p-dropdown>
      </div>
      <div class="p-col-12 p-md-4">
        <label>Dates</label>
        <br />
        <p-calendar
          appendTo="body"
          formControlName="customPeriod"
          (onClose)="resetCustomPeriod()"
          selectionMode="range"
          [readonlyInput]="true"
          styleClass="full-width"
          inputId="range"
        ></p-calendar>
      </div>
      <div class="p-col-12 p-d-flex p-ai-center">
        <p-chip
          *ngFor="let chip of chips"
          [label]="chip.name + ': ' + (chip.value | filterValue)"
          class="p-mr-2"
          [removable]="true"
          (onRemove)="resetFilter(chip.ctrlName)"
        ></p-chip>
        <app-add-filter
          *ngIf="filters"
          #addFilter
          [filters]="filters"
        ></app-add-filter>
      </div>
    </div>
  </div>
</div>

<div class="card">
  <h3>Summary</h3>
  <div class="p-col" [formGroup]="reportParamsForm" *ngIf="reportParamsForm">
    <div class="p-grid">
      <div class="p-col-12 p-md-4">
        <label>Columns</label>
        <br />
        <p-multiSelect
          class="full-width-multiselect"
          [options]="aggregationColumnOptions"
          formControlName="aggregationColumns"
          optionlabel="label"
          optionValue="option"
        ></p-multiSelect>
      </div>
    </div>
  </div>
  <p-table
    [value]="aggregationRows"
    [loading]="reportQH.loading"
    breakpoint="620px"
    [reorderableColumns]="true"
    (onColReorder)="handleColReorder($event, 'aggregationColumns')"
  >
    <ng-template pTemplate="header">
      <tr>
        <th
          *ngFor="let header of aggregationHeaders"
          pReorderableColumn
          (dragStart)="setReorderIndicatorVisibility('visible')"
          (dragend)="setReorderIndicatorVisibility('hidden')"
        >
          {{ header }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td *ngFor="let header of aggregationHeaders; index as i">
          <span>{{ row[i] }}</span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div class="card">
  <div class="header-with-button">
    <h3>Data</h3>
    <div class="p-d-flex">
      <div class="p-d-flex p-flex-column p-mr-2">
        <p-button
          label="Refresh"
          styleClass="full-width"
          icon="pi pi-refresh"
          (onClick)="previewReport()"
          [disabled]="!refreshEnabled || actionsLoading || reportQH.loading"
          [outlined]="true"
        ></p-button>
        <div class="p-mt-1" *ngIf="lastRefresh">
          Refreshed <app-time-since [unixTime]="lastRefresh"></app-time-since>
        </div>
        <div class="p-mt-1" *ngIf="!lastRefresh">Loading...</div>
      </div>
      <p-splitButton
        [label]="actionsLoading ? 'Processing...' : 'Copy Data'"
        [icon]="actionsLoading ? 'pi pi-spin pi-spinner' : 'pi pi-copy'"
        (onClick)="copyToClipboard()"
        [model]="dataActions"
        [disabled]="actionsLoading || reportQH.loading"
        appendTo="body"
      ></p-splitButton>
    </div>
  </div>
  <p-message
    severity="warn"
    text="This report may contain duplicate revenue, i.e. some charges may be added to multiple rows."
    styleClass="p-ml-2"
    *ngIf="groupByWithDuplicateRevenue[groupBy]"
  >
  </p-message>
  <p-message
    severity="warn"
    text="Job-level crew pay values repeat on each event row for multi-event jobs. Do not sum crew pay columns without deduplicating by job and crew member."
    styleClass="p-ml-2"
    *ngIf="groupBy === 'eventCrewMember'"
  >
  </p-message>
  <div class="p-col" [formGroup]="reportParamsForm" *ngIf="reportParamsForm">
    <div class="p-grid">
      <div class="p-col-12 p-md-6">
        <label>Group By</label>
        <br />
        <p-dropdown
          [options]="groupByOpts"
          formControlName="groupBy"
          optionlabel="label"
          optionValue="option"
          styleClass="full-width"
        ></p-dropdown>
      </div>
      <div class="p-col-12 p-md-6">
        <label>Columns</label>
        <br />
        <p-multiSelect
          class="full-width-multiselect"
          [options]="dataColumnOptions"
          formControlName="dataColumns"
          optionlabel="label"
          optionValue="option"
        ></p-multiSelect>
      </div>
    </div>
  </div>
  <p-table
    *ngIf="reportParamsForm"
    [value]="dataRows"
    [paginator]="true"
    (onLazyLoad)="retrieveMoreRows($event)"
    [lazy]="true"
    [totalRecords]="reportQH.total"
    [rows]="reportParamsForm.value.limit"
    [(first)]="reportQH.skip"
    [rowsPerPageOptions]="pagination.rowPerPageOptions"
    [loading]="reportQH.loading"
    [showCurrentPageReport]="!reportQH.loading"
    [reorderableColumns]="true"
    (onColReorder)="handleColReorder($event, 'dataColumns')"
    breakpoint="620px"
  >
    <ng-template pTemplate="header">
      <tr>
        <th
          *ngFor="let header of dataHeaders; index as i"
          pReorderableColumn
          (dragStart)="setReorderIndicatorVisibility('visible')"
          (dragend)="setReorderIndicatorVisibility('hidden')"
        >
          <div class="data-header">
            {{ header }}
            <app-sort-button
              [key]="(reportParamsForm.get('dataColumns')?.value || [])[i]"
              [currentSortBy]="reportParamsForm.get('sort').value"
              (sortByChanged)="changeSortBy($event)"
            ></app-sort-button>
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td *ngFor="let header of dataHeaders; index as i">
          <app-report-data
            [content]="row[i]"
            [column]="groupBy | titlecase"
            [row]="row"
          ></app-report-data>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<div class="card">
  <div class="header-with-button">
    <h3>Schedule</h3>
    <p-button
      label="Schedule"
      [pTooltip]="
        !existingReport ? 'You must save your report before scheduling' : ''
      "
      tooltipPosition="left"
      class="p-mr-2"
      icon="pi pi-calendar-plus"
      (onClick)="openCreateScheduleReportDialog()"
      [disabled]="reportQH.loading || !existingReport"
      [outlined]="true"
    ></p-button>
  </div>
  <app-scheduled-reports-list
    *ngIf="existingReport; else emptySchedule"
    [load]="true"
    [dynamicReportId]="existingReport.id"
  >
  </app-scheduled-reports-list>
</div>

<ng-template #emptySchedule>
  <p-table #table>
    <ng-template pTemplate="header">
      <tr>
        <th>Name</th>
        <th>Zone</th>
        <th>Last Run</th>
        <th>Next Run</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body"> </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="'6'" class="empty txt">Nothing scheduled</td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>

<div [formGroup]="reportParamsForm" *ngIf="reportParamsForm">
  <ng-template appTemplateType="jobStage">
    <div class="p-mb-1">
      <label>Job Stage</label>
    </div>
    <p-listbox
      [options]="jobStages"
      [multiple]="true"
      [checkbox]="true"
      formControlName="jobStage"
      optionlabel="label"
      optionValue="option"
    ></p-listbox>
  </ng-template>
  <ng-template appTemplateType="jobState">
    <div class="p-mb-1">
      <label>Job State</label>
    </div>
    <p-listbox
      [options]="jobStates"
      [multiple]="true"
      [checkbox]="true"
      formControlName="jobState"
      optionlabel="label"
      optionValue="option"
    ></p-listbox>
  </ng-template>
  <ng-template appTemplateType="currency">
    <div class="p-mb-1">
      <label>Currency</label>
    </div>
    <p-dropdown
      [options]="currencyOptions"
      formControlName="currency"
      styleClass="full-width"
      appendTo="body"
    ></p-dropdown>
  </ng-template>
  <ng-template appTemplateType="jobFranchises">
    <div class="p-mb-1">
      <label>Business Unit</label>
    </div>
    <p-listbox
      [options]="franchiseOptions"
      [multiple]="true"
      [checkbox]="true"
      [filter]="true"
      formControlName="jobFranchises"
      optionLabel="label"
      optionValue="option"
    ></p-listbox>
  </ng-template>

  <ng-template appTemplateType="jobAreas">
    <div class="p-mb-1">
      <label>Area</label>
    </div>
    <p-listbox
      [options]="areaOptions"
      [multiple]="true"
      [checkbox]="true"
      [filter]="true"
      formControlName="jobAreas"
      optionLabel="label"
      optionValue="option"
    ></p-listbox>
  </ng-template>

  <ng-template appTemplateType="expenseIds">
    <div class="p-mb-1">
      <label>Expenses</label>
    </div>
    <p-listbox
      [options]="expenseOptions"
      [multiple]="true"
      [checkbox]="true"
      [filter]="true"
      [filterValue]="expensesQuery$ | async"
      (onFilter)="searchExpenses($event.filter)"
      formControlName="expenseIds"
      optionlabel="label"
      optionValue="option"
    ></p-listbox>
  </ng-template>
  <ng-template appTemplateType="taxIds">
    <div class="p-mb-1">
      <label>Taxes</label>
    </div>
    <p-listbox
      [options]="taxOptions"
      [multiple]="true"
      [checkbox]="true"
      [filter]="true"
      formControlName="taxIds"
      optionLabel="label"
      optionValue="option"
    ></p-listbox>
  </ng-template>
  <ng-template appTemplateType="jobSources">
    <div class="p-mb-4">
      <div class="p-mb-1">
        <label>Source (tiered)</label>
      </div>
      <p-treeSelect
        [options]="sourceTierTree"
        [ngModel]="selectedSourceTierNodes"
        [ngModelOptions]="{ standalone: true }"
        selectionMode="checkbox"
        [metaKeySelection]="false"
        [filter]="true"
        filterBy="label,key"
        placeholder="Select source tiers"
        [showClear]="true"
        appendTo="body"
        [style]="{ width: '100%' }"
        scrollHeight="40vh"
        (ngModelChange)="onSourceTierSelectionChange($event)"
      ></p-treeSelect>
    </div>
    <div class="p-mb-4">
      <div class="p-mb-1">
        <label>Source (exact match)</label>
      </div>
      <p-chips
        formControlName="jobSources"
        class="full-width-chips"
        styleClass="full-width"
        class="full-width-chips"
      ></p-chips>
    </div>
    <div class="p-mb-1">
      <div class="p-mb-1">
        <label>No Source</label>
      </div>
      <p-checkbox
        formControlName="noSource"
        binary="true"
        label="No Source"
      ></p-checkbox>
    </div>
  </ng-template>
  <ng-template appTemplateType="jobOrigins">
    <div class="p-mb-4">
      <div class="p-mb-1">
        <label>Origins</label>
      </div>
      <p-chips
        formControlName="jobOrigins"
        class="full-width-chips"
        styleClass="full-width"
        class="full-width-chips"
      ></p-chips>
    </div>
    <div class="p-mb-1">
      <div class="p-mb-1">
        <label>No Origin</label>
      </div>
      <p-checkbox
        formControlName="noOrigin"
        binary="true"
        label="No Origin"
      ></p-checkbox>
    </div>
  </ng-template>
  <ng-template appTemplateType="jobTypes">
    <div class="p-mb-1">
      <label>Types</label>
    </div>
    <p-chips
      formControlName="jobTypes"
      class="full-width-chips"
      styleClass="full-width"
      class="full-width-chips"
    ></p-chips>
  </ng-template>
  <ng-template appTemplateType="jobEstimateMethods">
    <div class="p-mb-1">
      <label>Estimate Methods</label>
    </div>
    <p-chips
      formControlName="jobEstimateMethods"
      class="full-width-chips"
      styleClass="full-width"
      class="full-width-chips"
    ></p-chips>
  </ng-template>
  <ng-template appTemplateType="jobEstimators">
    <div class="p-mb-1">
      <label>Estimators</label>
    </div>
    <app-select-user-ids
      formControlName="jobEstimators"
      [(userRecord)]="userRecord"
    ></app-select-user-ids>
  </ng-template>
  <ng-template appTemplateType="jobSalesAgents">
    <div class="p-mb-1">
      <label>Sales Agents</label>
    </div>
    <app-select-user-ids formControlName="jobSalesAgents"></app-select-user-ids>
  </ng-template>
  <ng-template appTemplateType="attentionExplanation">
    <div class="p-mb-4">
      <div class="p-mb-1">
        <label>Needs Attention Reason</label>
      </div>
      <p-chips
        formControlName="attentionExplanations"
        class="full-width-chips"
        styleClass="full-width"
        class="full-width-chips"
      ></p-chips>
    </div>
    <div class="p-mb-1">
      <div class="p-mb1-1">
        <label>Does Not Require Attention</label>
      </div>
      <p-checkbox
        formControlName="noAttentionExplanation"
        binary="true"
        label="Does Not Require Attention"
      ></p-checkbox>
    </div>
  </ng-template>
  <ng-template appTemplateType="closedReason">
    <div class="p-mb-1">
      <label>Job Closure Reason</label>
    </div>
    <input
      type="text"
      formControlName="closedReason"
      pInputText
      placeholder="Job Closure Reason"
      data-cy="search-text-field"
    />
    <div class="p-mt-4 p-mb-1">
      <label>Exclude Closure Reasons</label>
    </div>
    <p-chips
      formControlName="excludeClosedReasons"
      class="full-width-chips"
      styleClass="full-width"
      placeholder="Closure reason id, e.g. customer_no_show_estimate"
    ></p-chips>
  </ng-template>
  <ng-template appTemplateType="utmSource">
    <div class="p-mb-4">
      <div class="p-mb-1">
        <label>UTM Source</label>
      </div>
      <p-chips
        formControlName="utmSources"
        class="full-width-chips"
        styleClass="full-width"
        class="full-width-chips"
      ></p-chips>
    </div>
    <div class="p-mb-1">
      <div class="p-mb1-1">
        <label>No UTM Source</label>
      </div>
      <p-checkbox
        formControlName="noUtmSource"
        binary="true"
        label="No UTM Source"
      ></p-checkbox>
    </div>
  </ng-template>
  <ng-template appTemplateType="utmMedium">
    <div class="p-mb-4">
      <div class="p-mb-1">
        <label>UTM Medium</label>
      </div>
      <p-chips
        formControlName="utmMedia"
        class="full-width-chips"
        styleClass="full-width"
        class="full-width-chips"
      ></p-chips>
    </div>
    <div class="p-mb-1">
      <div class="p-mb1-1">
        <label>No UTM Medium</label>
      </div>
      <p-checkbox
        formControlName="noUtmMedium"
        binary="true"
        label="No UTM Medium"
      ></p-checkbox>
    </div>
  </ng-template>
  <ng-template appTemplateType="utmContents">
    <div class="p-mb-4">
      <div class="p-mb-1">
        <label>UTM Content</label>
      </div>
      <p-chips
        formControlName="utmContents"
        class="full-width-chips"
        styleClass="full-width"
        class="full-width-chips"
      ></p-chips>
    </div>
    <div class="p-mb-1">
      <div class="p-mb1-1">
        <label>No UTM Content</label>
      </div>
      <p-checkbox
        formControlName="noUtmContent"
        binary="true"
        label="No UTM Content"
      ></p-checkbox>
    </div>
  </ng-template>
  <ng-template appTemplateType="utmTerms">
    <div class="p-mb-4">
      <div class="p-mb-1">
        <label>UTM Term</label>
      </div>
      <p-chips
        formControlName="utmTerms"
        class="full-width-chips"
        styleClass="full-width"
        class="full-width-chips"
      ></p-chips>
    </div>
    <div class="p-mb-1">
      <div class="p-mb1-1">
        <label>No UTM Term</label>
      </div>
      <p-checkbox
        formControlName="noUtmTerm"
        binary="true"
        label="No UTM Term"
      ></p-checkbox>
    </div>
  </ng-template>
  <ng-template appTemplateType="utmCampaign">
    <div class="p-mb-4">
      <div class="p-mb-1">
        <label>UTM Campaign</label>
      </div>
      <p-chips
        formControlName="utmCampaigns"
        class="full-width-chips"
        styleClass="full-width"
        class="full-width-chips"
      ></p-chips>
    </div>
    <div class="p-mb-1">
      <div class="p-mb1-1">
        <label>No UTM Campaign</label>
      </div>
      <p-checkbox
        formControlName="noUtmCampaign"
        binary="true"
        label="No UTM Campaign"
      ></p-checkbox>
    </div>
  </ng-template>
  <ng-template appTemplateType="jobHasCompletedEventOfType">
    <div class="p-mb-1">
      <label>Has Completed Event of Type</label>
    </div>
    <p-listbox
      [options]="eventTypeOptions"
      [multiple]="true"
      [checkbox]="true"
      formControlName="jobHasCompletedEventOfType"
      optionlabel="label"
      optionValue="option"
    ></p-listbox>
  </ng-template>
  <ng-template appTemplateType="eventStatus">
    <div class="p-mb-1">
      <label>Event Status</label>
    </div>
    <p-listbox
      [options]="eventStatuses"
      [multiple]="true"
      [checkbox]="true"
      formControlName="eventStatuses"
      optionlabel="label"
      optionValue="option"
    ></p-listbox>
  </ng-template>
  <ng-template appTemplateType="eventType">
    <div class="p-mb-1">
      <label>Event Type</label>
    </div>
    <p-listbox
      [options]="eventTypeOptions"
      [multiple]="true"
      [checkbox]="true"
      formControlName="eventTypes"
      optionlabel="label"
      optionValue="option"
    ></p-listbox>
  </ng-template>
  <ng-template appTemplateType="eventSharedStatus">
    <div class="p-mb-1">
      <label>Shared</label>
    </div>
    <p-listbox
      [options]="eventSharedStatuses"
      [multiple]="true"
      [checkbox]="true"
      formControlName="eventSharedStatuses"
      optionlabel="label"
      optionValue="option"
    ></p-listbox>
  </ng-template>
  <ng-template appTemplateType="bookedOnDaysOfWeek">
    <div class="p-mb-1">
      <label>Booked On Day of the Week</label>
    </div>
    <p-listbox
      [options]="daysOfTheWeek"
      [multiple]="true"
      [checkbox]="true"
      formControlName="bookedOnDaysOfWeek"
      optionlabel="label"
      optionValue="option"
    ></p-listbox>
  </ng-template>
  <ng-template appTemplateType="bookedFromHour">
    <div class="p-mb-1">
      <label>Booked No Earlier Than</label>
    </div>
    <p-calendar [timeOnly]="true" formControlName="bookedFromHour"></p-calendar>
  </ng-template>
  <ng-template appTemplateType="bookedUntilHour">
    <div class="p-mb-1">
      <label>Booked No Later Than</label>
    </div>
    <p-calendar
      [timeOnly]="true"
      formControlName="bookedUntilHour"
    ></p-calendar>
  </ng-template>
  <ng-template appTemplateType="distanceMin">
    <div class="p-mb-1">
      <label>Distance Min</label>
    </div>
    <p-inputNumber
      placeholder="Distance Min (meters)"
      formControlName="distanceMin"
    ></p-inputNumber>
  </ng-template>
  <ng-template appTemplateType="distanceMax">
    <div class="p-mb-1">
      <label>Distance Max</label>
    </div>
    <p-inputNumber
      placeholder="Distance Max (meters)"
      formControlName="distanceMax"
    ></p-inputNumber>
  </ng-template>
  <ng-template appTemplateType="realizedBy">
    <div class="p-mb-1">
      <label>Realized By</label>
      <br />
      <small
        >When requesting "Realized revenue" or "unrealized revenue" columns,
        only count as 'realized' revenue for events that were completed by this
        date .</small
      >
    </div>
    <p-calendar
      appendTo="body"
      formControlName="realizedBy"
      styleClass="full-width"
      [showTime]="true"
      [hourFormat]="24"
      inputId="range"
      (onBlur)="refreshReport()"
    ></p-calendar>
  </ng-template>
  <ng-template appTemplateType="invoiceStatus">
    <div class="p-mb-1">
      <label>Invoice Status</label>
    </div>
    <p-listbox
      [options]="invoiceStatuses"
      [multiple]="true"
      [checkbox]="true"
      formControlName="invoiceStatuses"
      optionlabel="label"
      optionValue="option"
    ></p-listbox>
  </ng-template>
  <ng-template appTemplateType="invoiceBalance">
    <div class="p-mb-1">
      <label>Invoice Status</label>
    </div>
    <p-listbox
      [options]="invoiceBalances"
      [multiple]="true"
      [checkbox]="true"
      formControlName="invoiceBalances"
      optionlabel="label"
      optionValue="option"
    ></p-listbox>
  </ng-template>
  <ng-template appTemplateType="transactionStage">
    <div class="p-mb-1">
      <label>Transaction Status</label>
    </div>
    <p-listbox
      [options]="transactionStages"
      [multiple]="true"
      [checkbox]="true"
      formControlName="transactionStages"
      optionlabel="label"
      optionValue="option"
    ></p-listbox>
  </ng-template>
  <ng-template appTemplateType="excludeDamages">
    <div class="p-mb-1">
      <label>Exclude Damages</label>
    </div>
    <p-checkbox
      formControlName="excludeDamages"
      binary="true"
      label="Exclude Damages"
    ></p-checkbox>
  </ng-template>
  <ng-template appTemplateType="excludeZeroTotalEvents">
    <div class="p-mb-1">
      <label>Exclude Zero-Total Events</label>
    </div>
    <p-checkbox
      formControlName="excludeZeroTotalEvents"
      binary="true"
      label="Exclude Zero-Total Events"
    ></p-checkbox>
  </ng-template>
  <ng-template appTemplateType="countRevenueFromEventsWithStatus">
    <div class="p-mb-1">
      <label>Count Revenue from Events With Status</label>
    </div>
    <p-listbox
      [options]="eventStatuses"
      [multiple]="true"
      [checkbox]="true"
      formControlName="countRevenueFromEventsWithStatus"
      optionlabel="label"
      optionValue="option"
    ></p-listbox>
  </ng-template>

  <ng-template appTemplateType="callModes">
    <div class="p-mb-1">
      <label>Call Mode</label>
    </div>
    <p-listbox
      [options]="callModes"
      [multiple]="true"
      [checkbox]="true"
      formControlName="callModes"
      optionlabel="label"
      optionValue="option"
    ></p-listbox>
  </ng-template>

  <ng-template appTemplateType="callFromNumber">
    <div class="p-mb-1">
      <label>From Number</label>
    </div>
    <input
      type="text"
      formControlName="callFromNumber"
      pInputText
      placeholder="From Number"
    />
  </ng-template>

  <ng-template appTemplateType="callToNumber">
    <div class="p-mb-1">
      <label>To Number</label>
    </div>
    <input
      type="text"
      formControlName="callToNumber"
      pInputText
      placeholder="To Number"
    />
  </ng-template>

  <ng-template appTemplateType="callClosedReasons">
    <div class="p-mb-1">
      <label>Closed Reason</label>
    </div>
    <p-chips
      formControlName="callClosedReasons"
      class="full-width-chips"
      styleClass="full-width"
    ></p-chips>
  </ng-template>

  <ng-template appTemplateType="callDispositions">
    <div class="p-mb-1">
      <label>Disposition</label>
    </div>
    <p-chips
      formControlName="callDispositions"
      class="full-width-chips"
      styleClass="full-width"
    ></p-chips>
  </ng-template>

  <ng-template appTemplateType="callOrigins">
    <div class="p-mb-1">
      <label>Origin</label>
    </div>
    <p-chips
      formControlName="callOrigins"
      class="full-width-chips"
      styleClass="full-width"
    ></p-chips>
  </ng-template>

  <ng-template appTemplateType="callStatuses">
    <div class="p-mb-1">
      <label>Status</label>
    </div>
    <p-chips
      formControlName="callStatuses"
      class="full-width-chips"
      styleClass="full-width"
    ></p-chips>
  </ng-template>

  <ng-template appTemplateType="callCallStatuses">
    <div class="p-mb-1">
      <label>Call Status</label>
    </div>
    <p-chips
      formControlName="callCallStatuses"
      class="full-width-chips"
      styleClass="full-width"
    ></p-chips>
  </ng-template>

  <ng-template appTemplateType="callFromCities">
    <div class="p-mb-1">
      <label>From City</label>
    </div>
    <p-chips
      formControlName="callFromCities"
      class="full-width-chips"
      styleClass="full-width"
    ></p-chips>
  </ng-template>

  <ng-template appTemplateType="callFromStates">
    <div class="p-mb-1">
      <label>From State</label>
    </div>
    <p-chips
      formControlName="callFromStates"
      class="full-width-chips"
      styleClass="full-width"
    ></p-chips>
  </ng-template>

  <ng-template appTemplateType="callFromZips">
    <div class="p-mb-1">
      <label>From Zip</label>
    </div>
    <p-chips
      formControlName="callFromZips"
      class="full-width-chips"
      styleClass="full-width"
    ></p-chips>
  </ng-template>

  <ng-template appTemplateType="callFromCountries">
    <div class="p-mb-1">
      <label>From Country</label>
    </div>
    <p-chips
      formControlName="callFromCountries"
      class="full-width-chips"
      styleClass="full-width"
    ></p-chips>
  </ng-template>

  <ng-template appTemplateType="callToCities">
    <div class="p-mb-1">
      <label>To City</label>
    </div>
    <p-chips
      formControlName="callToCities"
      class="full-width-chips"
      styleClass="full-width"
    ></p-chips>
  </ng-template>

  <ng-template appTemplateType="callToStates">
    <div class="p-mb-1">
      <label>To State</label>
    </div>
    <p-chips
      formControlName="callToStates"
      class="full-width-chips"
      styleClass="full-width"
    ></p-chips>
  </ng-template>

  <ng-template appTemplateType="callToZips">
    <div class="p-mb-1">
      <label>To Zip</label>
    </div>
    <p-chips
      formControlName="callToZips"
      class="full-width-chips"
      styleClass="full-width"
    ></p-chips>
  </ng-template>

  <ng-template appTemplateType="callToCountries">
    <div class="p-mb-1">
      <label>To Country</label>
    </div>
    <p-chips
      formControlName="callToCountries"
      class="full-width-chips"
      styleClass="full-width"
    ></p-chips>
  </ng-template>

  <ng-template appTemplateType="callStirVerstat">
    <div class="p-mb-1">
      <label>STIR/Verstat</label>
    </div>
    <input
      type="text"
      formControlName="callStirVerstat"
      pInputText
      placeholder="STIR/Verstat"
    />
  </ng-template>

  <ng-template appTemplateType="callTdInteractionId">
    <div class="p-mb-1">
      <label>TD Interaction ID</label>
    </div>
    <input
      type="text"
      formControlName="callTdInteractionId"
      pInputText
      placeholder="TD Interaction ID"
    />
  </ng-template>

  <ng-template appTemplateType="callTwilioApiVersion">
    <div class="p-mb-1">
      <label>Twilio API Version</label>
    </div>
    <input
      type="text"
      formControlName="callTwilioApiVersion"
      pInputText
      placeholder="Twilio API Version"
    />
  </ng-template>

  <ng-template appTemplateType="callTwilioAccountSids">
    <div class="p-mb-1">
      <label>Twilio Account SID</label>
    </div>
    <p-chips
      formControlName="callTwilioAccountSids"
      class="full-width-chips"
      styleClass="full-width"
    ></p-chips>
  </ng-template>

  <ng-template appTemplateType="callTwilioCallbackSources">
    <div class="p-mb-1">
      <label>Twilio Callback Source</label>
    </div>
    <p-chips
      formControlName="callTwilioCallbackSources"
      class="full-width-chips"
      styleClass="full-width"
    ></p-chips>
  </ng-template>

  <ng-template appTemplateType="callCommentAuthors">
    <div class="p-mb-1">
      <label>Comment Author</label>
    </div>
    <p-chips
      formControlName="callCommentAuthors"
      class="full-width-chips"
      styleClass="full-width"
    ></p-chips>
  </ng-template>

  <ng-template appTemplateType="callCommentIsSystem">
    <div class="p-mb-1">
      <label>Comment Is System</label>
    </div>
    <p-checkbox
      formControlName="callCommentIsSystem"
      binary="true"
      label="Is System"
    ></p-checkbox>
  </ng-template>

  <ng-template appTemplateType="callCommentAddedByIds">
    <div class="p-mb-1">
      <label>Comment Added By</label>
    </div>
    <app-select-user-ids
      formControlName="callCommentAddedByIds"
      [(userRecord)]="userRecord"
    ></app-select-user-ids>
  </ng-template>

  <ng-template appTemplateType="callCommentIsAutodialer">
    <div class="p-mb-1">
      <label>Comment Is Autodialer</label>
    </div>
    <p-checkbox
      formControlName="callCommentIsAutodialer"
      binary="true"
      label="Is Autodialer"
    ></p-checkbox>
  </ng-template>

  <ng-template appTemplateType="callCommentExternalMessageIds">
    <div class="p-mb-1">
      <label>Comment External Message ID</label>
    </div>
    <p-chips
      formControlName="callCommentExternalMessageIds"
      class="full-width-chips"
      styleClass="full-width"
    ></p-chips>
  </ng-template>

  <ng-template appTemplateType="callCommentProviders">
    <div class="p-mb-1">
      <label>Comment Provider</label>
    </div>
    <p-chips
      formControlName="callCommentProviders"
      class="full-width-chips"
      styleClass="full-width"
    ></p-chips>
  </ng-template>

  <ng-template appTemplateType="callCommentRingGroups">
    <div class="p-mb-1">
      <label>Comment Ring Group</label>
    </div>
    <p-chips
      formControlName="callCommentRingGroups"
      class="full-width-chips"
      styleClass="full-width"
    ></p-chips>
  </ng-template>
</div>

<p-dialog
  header="Semi-Live Export to Google Sheets"
  [(visible)]="exportDialogOpen"
  [modal]="true"
  [breakpoints]="{ '992px': '62vw', '510px': '93vw' }"
  [style]="{ width: '50vw' }"
>
  <span>
    Keep an up to date copy of {{ existingReport?.name }} in a Google Sheet.
  </span>
  <br /><br />
  <ul>
    <li>
      Copy the formula below by clicking on it and paste it into a Google Sheet
      cell with CTRL + V.
    </li>
    <li>
      Google Sheets may ask you to allow access to third-party links. Click on
      "Allow access" to enable the formula to work.
    </li>
    <li>Google Sheets will run this report every hour.</li>
    <li>
      This formula will only be valid for a year then you will have to generate
      a new one.
    </li>
    <li>
      <strong>
        Keep this formula a secret! It gives anyone with this formula access to
        your report!
      </strong>
    </li>
  </ul>
  <div class="p-my-4">
    <div
      [formGroup]="exportSettingsForm"
      class="p-d-flex p-jc-evenly"
      style="gap: 0.5rem"
    >
      <div class="p-d-flex p-ai-center" style="gap: 0.5rem">
        <p-checkbox
          formControlName="includeSummary"
          binary="true"
          inputId="includeSummary"
        ></p-checkbox>
        <label for="includeSummary">Include Summary</label>
      </div>
      <div class="p-d-flex p-ai-center" style="gap: 0.5rem">
        <p-checkbox
          formControlName="includeData"
          binary="true"
          inputId="includeData"
        ></p-checkbox>
        <label for="includeData">Include Data</label>
      </div>
    </div>
    <small
      class="field-error-message p-text-center p-mt-2"
      *ngIf="exportSettingsForm.hasError('noSelection')"
    >
      Must include either Summary or Data
    </small>
  </div>
  <app-copy-button
    *ngIf="exportFormula"
    [content]="exportFormula"
    [disabled]="
      exportSettingsForm.hasError('noSelection') || exportTokenRefreshing
    "
  ></app-copy-button>
  <div class="p-mt-3 p-d-flex p-jc-center">
    <p-button
      (click)="copyFormulaAndCreateNewSheet()"
      [label]="
        exportTokenRefreshing
          ? 'Refreshing link'
          : 'Copy formula and create new sheet'
      "
      class="p-mt-2"
      icon="pi pi-file-excel"
      [disabled]="
        !exportFormula ||
        exportSettingsForm.hasError('noSelection') ||
        exportTokenRefreshing
      "
    ></p-button>
  </div>
</p-dialog>

<p-dialog
  header="Add Calculator Column"
  [(visible)]="calculatorDialogOpen"
  [modal]="true"
  [breakpoints]="{ '992px': '62vw', '510px': '93vw' }"
  [style]="{ width: '40vw' }"
>
  <div [formGroup]="calculatorColumnForm" *ngIf="calculatorColumnForm">
    <div class="p-fluid">
      <div
        class="p-field p-mb-3"
        *appVar="calculatorColumnForm.get('columnKey') as control"
      >
        <label for="columnKey"
          >Column Key<span class="required-asterisk">*</span></label
        >
        <input
          id="columnKey"
          type="text"
          formControlName="columnKey"
          pInputText
          placeholder="Enter column key (no spaces)"
        />
        <app-validation-messages
          [control]="control"
          [requireTouched]="true"
          fieldName="Column key"
        ></app-validation-messages>
      </div>

      <div class="p-field p-mb-3">
        <label for="format">Format</label>
        <input
          id="format"
          type="text"
          formControlName="format"
          pInputText
          placeholder="Enter format"
        />
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="Add"
      icon="pi pi-check"
      (onClick)="addCalculatorColumn()"
      [disabled]="calculatorColumnForm?.invalid"
    ></p-button>
  </ng-template>
</p-dialog>

<p-dialog
  header="Advanced Settings"
  [(visible)]="advanceSettingsDialogOpen"
  [modal]="true"
  [breakpoints]="{ '992px': '40vw', '510px': '93vw' }"
  [style]="{ width: '30vw' }"
>
  <div [formGroup]="reportParamsForm" *ngIf="reportParamsForm">
    <div class="p-fluid">
      <div class="p-field p-mb-3">
        <label for="currencySource">Currency Source</label>
        <p-dropdown
          id="currencySource"
          [options]="currencySourceOptions"
          formControlName="currencySource"
          styleClass="full-width"
          appendTo="body"
        ></p-dropdown>
      </div>
      <div class="p-field p-mb-3">
        <label for="periodBucket">Period Bucket</label>
        <p-dropdown
          id="periodBucket"
          [options]="periodBucketOptions"
          formControlName="periodBucket"
          styleClass="full-width"
          appendTo="body"
        ></p-dropdown>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="Add Tax Column"
  [(visible)]="taxColumnDialogOpen"
  [modal]="true"
  [breakpoints]="{ '992px': '62vw', '510px': '93vw' }"
  [style]="{ width: '40vw' }"
>
  <div [formGroup]="taxColumnForm" *ngIf="taxColumnForm">
    <div class="p-fluid">
      <div
        class="p-field p-mb-3"
        *appVar="taxColumnForm.get('taxType') as control"
      >
        <label for="taxType"
          >Tax Type<span class="required-asterisk">*</span></label
        >
        <p-dropdown
          id="taxType"
          formControlName="taxType"
          [options]="taxTypeOptions"
          optionLabel="label"
          optionValue="option"
          placeholder="Select a tax type"
          [showClear]="true"
          appendTo="body"
        ></p-dropdown>
        <app-validation-messages
          [control]="control"
          [requireTouched]="true"
          fieldName="Tax type"
        ></app-validation-messages>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="Add"
      icon="pi pi-check"
      (onClick)="addTaxColumn()"
      [disabled]="taxColumnForm?.invalid"
    ></p-button>
  </ng-template>
</p-dialog>

<p-dialog
  header="Custom Column Names"
  [(visible)]="customColumnNamesDialogOpen"
  [modal]="true"
  [breakpoints]="{ '992px': '62vw', '510px': '93vw' }"
  [style]="{ width: '40vw' }"
>
  <div class="p-fluid">
    <p class="p-mb-3">
      Override the displayed name for any column. Leave blank to keep the
      default. Letters, digits, spaces, and basic punctuation only.
    </p>
    <ng-container
      *ngIf="
        (reportParamsForm?.get('dataColumns')?.value || []).length;
        else noColumns
      "
    >
      <div
        class="p-field p-grid p-ai-center p-mb-2"
        *ngFor="let column of reportParamsForm?.get('dataColumns')?.value || []"
      >
        <label class="p-col-4 p-mb-0" [for]="'customName-' + column">
          {{ customColumnNameLabel(column) }}
        </label>
        <div class="p-col-8">
          <input
            [id]="'customName-' + column"
            type="text"
            pInputText
            [(ngModel)]="customColumnNamesDialogValue[column]"
            [maxlength]="customColumnNameMaxLength"
            [placeholder]="customColumnNameLabel(column)"
          />
          <small
            class="p-error"
            *ngIf="
              isCustomColumnNameInvalid(customColumnNamesDialogValue[column])
            "
          >
            Letters, digits, spaces, and basic punctuation only.
          </small>
        </div>
      </div>
    </ng-container>
    <ng-template #noColumns>
      <p>Add columns to the report before customizing their names.</p>
    </ng-template>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="Apply"
      icon="pi pi-check"
      (onClick)="applyCustomColumnNames()"
      [disabled]="isCustomColumnNamesDialogInvalid()"
    ></p-button>
  </ng-template>
</p-dialog>
